document.addEventListener("DOMContentLoaded", function() {

  /* Header Top Bar Countdown */
  if (document.getElementById("strip-announcement-bar")) {
    var announcement_bar = document.querySelector('#strip-announcement-bar');
    var am_message = announcement_bar.dataset.amMessage;
    var pm_message = announcement_bar.dataset.pmMessage;
    var currentDate = new Date()
    var current_hour = currentDate.getHours();
    var strip_bar_message = document.querySelector('#announcement-bar__message');
    if (current_hour < 12){
      strip_bar_message.innerHTML = am_message;
    } else {
      strip_bar_message.innerHTML = pm_message;
    }
    announcement_bar.style.display = 'block';
  }

  /* Product Countdown */
  if (document.getElementById("product-countdown")) {
    var product_countdown = document.querySelector('#product-countdown');
    var cutoff = product_countdown.dataset.cutoff.split(":");
    var today = moment();
    var today_date_string = new Date();
    var todays_cutoff = moment(dateToJSONLocal(today_date_string) + ' ' + cutoff[0] + ':' + cutoff[1]);
          
    // Delivery Day
    if(moment().isoWeekday() == 1){
      if(today >= todays_cutoff){
        counting_down_from = 1;
        days_to_arrive = 2;
      } else {
        counting_down_from = 0;
        days_to_arrive = 1;
      }
    } else if(moment().isoWeekday() == 2){
      if(today >= todays_cutoff){
        counting_down_from = 1;
        days_to_arrive = 2;
      } else {
        counting_down_from = 0;
        days_to_arrive = 1;
      }
    } else if(moment().isoWeekday() == 3){
      if(today >= todays_cutoff){
        counting_down_from = 1;
        days_to_arrive = 2;
      } else {
        counting_down_from = 0;
        days_to_arrive = 1;
      }
    } else if(moment().isoWeekday() == 4){
      if(today >= todays_cutoff){
        counting_down_from = 1;
        days_to_arrive = 4;
      } else {
        counting_down_from = 0;
        days_to_arrive = 1;
      }
    } else if(moment().isoWeekday() == 5){
      if(today >= todays_cutoff){
        counting_down_from = 3;
        days_to_arrive = 4;
      } else {
        counting_down_from = 0;
        days_to_arrive = 3;
      }
    } else if(moment().isoWeekday() == 6){
      if(today >= todays_cutoff){
        counting_down_from = 2;
        days_to_arrive = 3;
      } else {
        counting_down_from = 2;
        days_to_arrive = 3;
      }
    } else {
      if(today >= todays_cutoff){
        counting_down_from = 1;
        days_to_arrive = 2;
      } else {
        counting_down_from = 1;
        days_to_arrive = 2;
      }
    }
    
    // If wanting to countdown to NOT the same day, switch the uncomments below
    //       var countdown_day_moment = moment().add(counting_down_from, 'days');
    //       countdown_day_moment.set({h: cutoff[0], m: cutoff[1], s: 00});
    var countdown_day_moment = moment();
    if(today >= todays_cutoff){
      countdown_day_moment.set({h: 23, m: 59, s: 59});
    } else {
      countdown_day_moment.set({h: cutoff[0], m: cutoff[1], s: 00});
    }
    
    var extra_days = product_countdown.dataset.extraDays;
    var total_days_to_arrive = days_to_arrive + parseInt(extra_days);
    var product_countdown_date = document.querySelector('#product-countdown__date');
    if(total_days_to_arrive == 1) {
      product_countdown_date.innerHTML = 'tomorrow';
    } else {
      var delivery_day_moment = moment().add(total_days_to_arrive, 'days');
      delivery_day_moment.set({h: cutoff[0], m: cutoff[1], s: 00});
      product_countdown_date.innerHTML = delivery_day_moment.format('dddd Do MMM');
    }
    
    // Countdown
    var timer = setInterval(function(){
      if(moment().isAfter(countdown_day_moment)){
        clearInterval(timer);
        product_countdown.style.display = 'none';
      } else {
        product_countdown.style.display = 'flex';
        var_live_days_countdown = '';
        if(countdown(countdown_day_moment).days != 0){
          var_live_days_countdown = countdown(countdown_day_moment).days + 'd ';
        } 
        var hours_string = parseInt(countdown(countdown_day_moment).hours) < 10 ? '0' + countdown(countdown_day_moment).hours : countdown(countdown_day_moment).hours;
        hours_string = hours_string == '00' ? '' : hours_string + 'h '
        var minutes_string = parseInt(countdown(countdown_day_moment).minutes) < 10 ? '0' + countdown(countdown_day_moment).minutes : countdown(countdown_day_moment).minutes;
        var seconds_string = parseInt(countdown(countdown_day_moment).seconds) < 10 ? '0' + countdown(countdown_day_moment).seconds : countdown(countdown_day_moment).seconds;
        var live_time = var_live_days_countdown + hours_string + minutes_string + 'm ' + seconds_string + 's ';
        var product_countdown_timer = document.querySelector('#product-countdown__timer');
        product_countdown_timer.innerHTML = live_time;
      }
    }, 1000);

  }

  /* Product Scarcity Bar */
  var product_scarcity_value = document.querySelector('#product-scarcity__value');
  var product_scarcity_progress = document.querySelector('#product-scarcity__progress');
  updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress);

  var stored_selected_variants = {};
  var selected_variant = getSelectedProductVariant();
  stored_selected_variants[selected_variant] = product_scarcity_value.innerHTML;
  
  const product_variant_dropdowns = document.querySelectorAll(".product-selectors select");
  for (let i = 0; i < product_variant_dropdowns.length; i++) {
    product_variant_dropdowns[i].addEventListener("change", function() {
      setTimeout(
        function() {
          var selected_variant = getSelectedProductVariant();
          if (!(selected_variant in stored_selected_variants)) {
            updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress);
            var selected_variant = getSelectedProductVariant();
            stored_selected_variants[selected_variant] = product_scarcity_value.innerHTML;
          } else {
            updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress, stored_selected_variants[selected_variant]);
          }
      }, 500);
    });
  }

  // Header Search
  // var search_bar_button = document.querySelector('.js-search-bar-button');
  // var search_bar = document.querySelector('.js-search-bar-wrapper');
  // search_bar_button.onclick = function(){
  //   console.log('toggle search');
  //   if (window.getComputedStyle(search_bar).display === 'block' || window.getComputedStyle(search_bar).display === 'inline') {
  //     search_bar.style.display = 'none';
  //   } else {
  //     if (window.innerWidth < 992) {
  //       search_bar.style.display = 'block';
  //     } else {
  //       search_bar.style.display = 'inline';
  //     }
  //   }
  // }

  // Read more questions
  const product_questions_read_more = document.querySelectorAll(".product-bottom__questions__read-more");
  for (let i = 0; i < product_questions_read_more.length; i++) {
    product_questions_read_more[i].onclick = function(){
      product_questions_read_more[i].parentNode.style.maxHeight = 'none';
      product_questions_read_more[i].parentNode.removeChild(product_questions_read_more[i]);
    }
  }
  
});

function dateToJSONLocal(date) {
  var local = new Date(date);
  local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
}

function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

function getSelectedProductVariant() {
  var selected_product_variant = document.querySelector("button.js-product-add-to-cart-button");
  return selected_product_variant.dataset.variantId;
}

function updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress, previously_set_level) {
  if (previously_set_level === undefined) {
    var scarcity_stock_level = randomNumber(1, 6);
  } else {
    var scarcity_stock_level = previously_set_level;
  }
  product_scarcity_value.innerHTML = scarcity_stock_level;
  var scarcity_percentage = (scarcity_stock_level / 8) * 100;
  product_scarcity_progress.style.width = scarcity_percentage + "%";
}